import { default as Container } from './GroupNotesListItemActions.container';
import { default as Component } from './GroupNotesListItemActions';
export default Container(Component);
